export const roundDecimals = (num) => Math.round((num + Number.EPSILON) * 100) / 100;
